import { SiteNumberAndName } from '@csp/csp-common-hbs-model';
import { AlertWarning } from '@csp/csp-web-ui';
import { Grid } from '@mui/material';
import { FC } from 'react';
import { BioSampleContentService } from '../../service/BioSampleContentService';

type Props = {
  mismatchingSites: SiteNumberAndName[];
};

export const KitContainerSiteAlert: FC<Props> = ({ mismatchingSites }) => {
  const { alert } = BioSampleContentService.getKitDetailsTexts();

  return mismatchingSites.length ? (
    <AlertWarning
      title={alert.alertWarning.kitNotMatchingSiteTitle.text}
      message={
        <Grid>
          {alert.alertWarning.kitNotMatchingSiteBody.text}
          {mismatchingSites.map(site => (
            <Grid key={site.siteNumber} container mt={2}>
              <Grid item xs={3}>
                {alert.alertWarning.kitNotMatchingSiteSiteNumber.text}:
              </Grid>
              <Grid item xs={9}>
                {site.siteNumber}
              </Grid>
              <Grid item xs={3}>
                {alert.alertWarning.kitNotMatchingSiteSiteName.text}:
              </Grid>
              <Grid item xs={9}>
                {site.siteName ?? ''}
              </Grid>
            </Grid>
          ))}
        </Grid>
      }
    />
  ) : null;
};
